import { render, staticRenderFns } from "./SelectTable.vue?vue&type=template&id=654262fc&scoped=true"
import script from "./SelectTable.vue?vue&type=script&lang=js"
export * from "./SelectTable.vue?vue&type=script&lang=js"
import style0 from "./SelectTable.vue?vue&type=style&index=0&id=654262fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654262fc",
  null
  
)

export default component.exports